export default __webpack_public_path__ + "static/media/euler-audio.041ff8b2.mp3";